import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataInfoCard, InfoCard, Infos } from 'src/app/models/dashboard/dashboard';

@Component({
  selector: 'app-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent implements OnInit {

  @Input() infoCard:InfoCard;
  @Output() handlerInfoCardEmit: EventEmitter<DataInfoCard> = new EventEmitter<DataInfoCard>();
  infosActive: Infos;

  constructor() { }

  ngOnInit(): void {
    this.infosActive = this.infoCard?.infos[0];
  }

  selectInfo( info: Infos ){
    this.infosActive.active = false;
    info.active = true;
    this.infosActive = info;
  }

  handlerInfoCard( isDiabled: boolean, title: string, path: string  ){
    this.handlerInfoCardEmit.emit({ isDiabled: isDiabled, title: title, path: path })
  }

}
